const cardLinks = [...document.querySelectorAll('.js-card-reveal-link')];
if (cardLinks.length) {
    cardLinks.forEach((card) => {
        card.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = e.currentTarget;
        });
    });
}
